import {
  ACCOUNT_FETCH_URI,
  connectionService,
  RACE_TIMEOUT,
  TERMS_CONDITIONS_FETCH_URI
} from '@leapsight/styleguide'

export default class {
  static accountInformationFetch(connection) {
    return new Promise((resolve, reject) => {
      const kwArgs = connectionService.createkwArgs()
      const accountId = connectionService.getAccountId()
      setTimeout(() => {
        connection.session
          .call(ACCOUNT_FETCH_URI, [accountId], kwArgs, {})
          .then(data => {
            resolve(data.args[0])
          })
          .catch(err => {
            console.log(err, 'err')
          })
      }, 500)
    })
  }

  static checkVersionTermsConditions(connection, lastVersionAcceptedTandC) {
    return new Promise((resolve, reject) => {
      const lastVersionTermsConditions = lastVersionAcceptedTandC
      const kwArgs = connectionService.createkwArgs()
      const p1 = new Promise(resolve => {
        setTimeout(resolve, RACE_TIMEOUT, false)
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(
            TERMS_CONDITIONS_FETCH_URI,
            [lastVersionTermsConditions],
            kwArgs,
            {}
          )
          .then(
            res => {
              const docs = res.docs
              let html = ''
              docs.map(doc => {
                html += doc.html
              })

              resolve(html)
            },
            wampError => {
              reject(wampError)
            }
          )
          .catch(err => {
            console.log('error ', err)
          })
      })

      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
